import { css } from 'styled-components';
// eslint-disable-next-line import/prefer-default-export
export const srOnly = css `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;
`;
